// extracted by mini-css-extract-plugin
export var footer = "gd_dj";
export var footer_inner = "gd_fj";
export var footer_copy = "gd_gj";